import { render, staticRenderFns } from "./memberViewPage.vue?vue&type=template&id=3b2e5fc1&scoped=true&"
import script from "./memberViewPage.vue?vue&type=script&lang=js&"
export * from "./memberViewPage.vue?vue&type=script&lang=js&"
import style0 from "./memberViewPage.vue?vue&type=style&index=0&id=3b2e5fc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e5fc1",
  null
  
)

export default component.exports